import type { APIAuthUserResponse } from '~/services/users/types';
import { me } from '~/services/users/users.service.api';
import getEoBrand from '~/utils/getEoBrand';
import { isRoutePublic } from '~/utils/isRoutePublic';
import type { BRANDS } from '~/domains/auth/consts';

import { fetchRefreshToken } from '../../token/refresh-token';

import { identityInstance } from './identity-instance';

const fetchUserWithRefreshToken = async (): Promise<APIAuthUserResponse> => {
  // A public page tolerates a failed boot refresh and renders anonymous; only a protected page
  // redirects to sign-in when the token can't be refreshed.
  const shouldRedirect = !isRoutePublic(window.location.pathname);
  await fetchRefreshToken(shouldRedirect);
  const user = await me();

  return user;
};

const logOut = async () => {
  const response = await identityInstance.post('/universal-auth/logout');

  return response.data;
};

const deactivateAccount = async () => {
  const response = await identityInstance.delete('/users/disable');

  return response.data;
};

const updatePersonalInfo = async (input: { firstName?: string; lastName?: string }) => {
  const response = await identityInstance.patch('/personal-info', input);
  return response.data;
};

export const generateAndStoreSingleUseToken = async (authToken?: string, destination?: BRANDS) => {
  const sutDestination = destination ?? getEoBrand();
  const url = sutDestination
    ? `/universal-auth/single-use-tokens?destination=${sutDestination}`
    : `/universal-auth/single-use-tokens`;

  const response = await identityInstance.get(url, {
    headers: {
      Authorization: authToken ? `Bearer ${authToken}` : undefined,
    },
  });

  return response.data;
};

export { fetchUserWithRefreshToken, logOut, deactivateAccount, updatePersonalInfo };
